import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface enumState {
  data: [] | null;
}

const initialState: enumState = {
  data: null,
};

export const enumSlice = createSlice({
  name: 'enumData',
  initialState,
  reducers: {
    setEnumData: (state, action) => {
      state.data = action.payload;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setEnumData, reset } = enumSlice.actions;

export const getEnumDataStore = (state: any) => state.enum.data;
export const getSpecificEnumData = (state: RootState) => state.enum.data;

export default enumSlice.reducer;
